
// See also /src/vue-components/wizard/util/pushWizardFormEvent.js

// Note on old vs. new events: New events all have INS_ prefix so they can all
// be handled by a single trigger in tag manager, also names have been adjusted
// so that they fit into the 40-character limit.

function pushInPageFormConversionEvent(content) {
  // Old style
  window.dataLayer.push({
    event: 'in-page-form-conversion',
    inPageFormIncentive: content.buttonText,
  })
  // New style
  window.dataLayer.push({
    event: 'INS_in_page_form_conversion',
    incentive: content.buttonText,
  })
}

function pushSimplePromoPopupEvent(action, content) {
  const eventDefsOld = {
    revealedAfterScrolling: {
      event: 'promo_popup_revealed',
      trigger: 'user_scrolled',
      heading: content.message,
    },
    revealedAfterTimeout: {
      event: 'promo_popup_revealed',
      trigger: 'timeout',
      heading: content.message,
    },
    revealedOnMobile: {
      event: 'promo_popup_revealed',
      trigger: 'mobile',
      heading: content.message,
    },
    dismissed: {
      event: 'promo_popup_dismissed',
      heading: content.message,
    },
    ctaClicked: {
      event: 'promo_popup_cta_clicked',
      heading: content.message,
      ctaText: content.cta?.text,
    },
  }
  const eventDefsNew = {
    revealedAfterScrolling: {
      event: 'INS_promo_popup_revealed',
      trigger: 'user_scrolled',
      heading: content.message,
    },
    revealedAfterTimeout: {
      event: 'INS_promo_popup_revealed',
      trigger: 'timeout',
      heading: content.message,
    },
    revealedOnMobile: {
      event: 'INS_promo_popup_revealed',
      trigger: 'mobile',
      heading: content.message,
    },
    dismissed: {
      event: 'INS_promo_popup_dismissed',
      heading: content.message,
    },
    ctaClicked: {
      event: 'INS_promo_popup_cta_clicked',
      heading: content.message,
      ctaText: content.cta?.text,
    },
  }
  window.dataLayer.push(eventDefsOld[action])
  window.dataLayer.push(eventDefsNew[action])
}

function pushMultichoicePromoPopupEvent(action, content) {
  const eventDefsOld = {
    revealedAfterScrolling: {
      event: 'promo_popup_multichoice_revealed',
      trigger: 'user_scrolled',
      heading: content.prompt,
    },
    revealedAfterTimeout: {
      event: 'promo_popup_multichoice_revealed',
      trigger: 'timeout',
      heading: content.prompt,
    },
    dismissed: {
      event: 'promo_popup_multichoice_dismissed',
      heading: content.prompt,
    },
    ctaClicked: {
      event: 'promo_popup_multichoice_cta_clicked',
      heading: content.prompt,
      ctaText: content.ctaText,
    },
    salesRequest: {
      event: 'promo_popup_multichoice_sales_request',
      heading: content.heading,
    },
    supportRequest: {
      event: 'promo_popup_multichoice_support_request',
      heading: content.heading,
    },
    leadFormConversion: {
      event: 'promo_popup_multichoice_lead_form_conver', // Clipped to 40 chars
      heading: content.prompt,
      brand: content.segment === 'fleet' ? 'inseegoFleet' : 'inseego',
    },
    gatedContentConversion: {
      event: 'promo_popup_multichoice_gated_content_co', // Clipped to 40 chars
      heading: content.prompt,
      requestedContent: content.requestedContent,
    },
    caseStudyClicked: {
      event: 'promo_popup_multichoice_case_study_click', // Clipped to 40 chars
      heading: content.prompt,
      label: content.caseStudyClicked,
    },
  }
  const eventDefsNew = {
    revealedAfterScrolling: {
      event: 'INS_promo_popup_revealed',
      trigger: 'user_scrolled',
      heading: content.prompt,
    },
    revealedAfterTimeout: {
      event: 'INS_promo_popup_revealed',
      trigger: 'timeout',
      heading: content.prompt,
    },
    dismissed: {
      event: 'INS_promo_popup_dismissed',
      heading: content.prompt,
    },
    ctaClicked: {
      event: 'INS_promo_popup_cta_clicked',
      heading: content.prompt,
      ctaText: content.ctaText,
    },
    salesRequest: {
      event: 'INS_promo_popup_sales_request',
      heading: content.heading,
    },
    supportRequest: {
      event: 'INS_promo_popup_support_request',
      heading: content.heading,
    },
    leadFormConversion: {
      event: 'INS_promo_popup_lead_form_conversion',
      heading: content.prompt,
      brand: content.segment === 'fleet' ? 'inseegoFleet' : 'inseego',
    },
    gatedContentConversion: {
      event: 'INS_promo_popup_gated_content_conversion',
      heading: content.prompt,
      requestedContent: content.requestedContent,
    },
    caseStudyClicked: {
      event: 'INS_promo_popup_case_study_clicked',
      heading: content.prompt,
      label: content.caseStudyClicked,
    },
  }
  window.dataLayer.push(eventDefsOld[action])
  window.dataLayer.push(eventDefsNew[action])
}

function pushGatedContentDownloadModuleEvent(action, content) {
  const eventDefs = {
    popupRevealedByUser: {
      event: 'INS_gated_content_popup_revealed',
      trigger: 'user_clicked_cta',
      heading: content.heading,
      requestedContent: content.requestedContent,
    },
    popupRevealedAfterTimeout: {
      event: 'INS_gated_content_popup_revealed',
      trigger: 'timeout',
      heading: content.heading,
      requestedContent: content.requestedContent,
    },
    popupDismissed: {
      event: 'INS_gated_content_popup_dismissed',
      heading: content.heading,
      requestedContent: content.requestedContent,
    },
    formConversion: {
      // Note that the 'content' object passed for this action differs from
      // that for the ones above.
      event: 'INS_gated_content_form_conversion',
      requestedContent: content.requestedContent,
      incentive: content.buttonText,
    },
  }
  window.dataLayer.push(eventDefs[action])
}

function pushVideoCarouselEvent(action, content) {
  const eventDefs = {
    playVideo: {
      event: 'INS_video_carousel_play_video',
      heading: content.heading,
      label: content.video.title,
    },
  }
  window.dataLayer.push(eventDefs[action])
}

export function pushAnalyticsEvent({ scope, action, content }) {
  switch (scope) {
  case 'inPageForm':
    if (action === 'conversion') {
      pushInPageFormConversionEvent(content)
    }
    break
  case 'simplePromoPopup':
    pushSimplePromoPopupEvent(action, content)
    break
  case 'multichoicePromoPopup':
    pushMultichoicePromoPopupEvent(action, content)
    break
  case 'gatedContentDownloadModule':
    pushGatedContentDownloadModuleEvent(action, content)
    break
  case 'videoCarousel':
    pushVideoCarouselEvent(action, content)
    break
  }
}
